import { useEffect, useRef } from "react";
import { LuCheck, LuCopy } from "react-icons/lu";
import { Link } from "react-router-dom";

import ShareActions, { useCopied } from "../components/ShareActions";
import { copyText } from "../lib/share";
import { careersPath } from "../lib/paths";

export default function ApplySuccess({ job, email, reference }) {
  const headingRef = useRef(null);
  const [copied, setCopied] = useCopied();

  useEffect(() => {
    headingRef.current?.focus();
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="cr-done">
      <span className="cr-done-mark" aria-hidden="true">
        <LuCheck />
      </span>
      <h1 className="cr-h1" ref={headingRef} tabIndex={-1}>
        Application sent
      </h1>
      <p className="cr-done-lede">
        Thanks for applying for {job.title}. We've emailed a confirmation to <strong>{email}</strong>.
      </p>

      <div className="cr-done-stack">
        {reference && (
          <div className="cr-card cr-ref">
            <div>
              <p className="cr-hint">Your reference</p>
              <p className="cr-ref-code">{reference}</p>
            </div>
            <button
              type="button"
              className="cr-btn cr-btn--secondary cr-btn--sm"
              onClick={async () => setCopied(await copyText(reference))}
            >
              {copied ? <LuCheck aria-hidden="true" /> : <LuCopy aria-hidden="true" />}
              {copied ? "Copied" : "Copy"}
            </button>
          </div>
        )}

        <div className="cr-card">
          <h2 className="cr-h2">What happens next</h2>
          <ol className="cr-next">
            <li>Our recruitment team reviews your application against the role.</li>
            <li>If you're shortlisted, we'll contact you by email or phone to arrange an interview.</li>
            <li>Keep your reference handy in case you need to get in touch.</li>
          </ol>
        </div>

        <div className="cr-card">
          <ShareActions job={job} title="Know someone who'd love it here? Send them this role." />
        </div>
      </div>

      <div className="cr-done-links">
        <Link to={careersPath()} className="cr-btn cr-btn--secondary">
          See other roles
        </Link>
      </div>
      <p className="cr-visually-hidden" role="status">
        {copied ? "Reference copied" : ""}
      </p>
    </div>
  );
}
